"use strict";

var _toConsumableArray = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/toConsumableArray.js").default;
var _classCallCheck = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/classCallCheck.js").default;
var _createClass = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/createClass.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CSSProcessedProps = void 0;
var _emptyProps = require("./emptyProps");
var _mergeProps = _interopRequireDefault(require("./mergeProps"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var compatCategories = ['native', 'web'];
var displayCategories = ['text', 'block'];
var propagationCategories = ['flow', 'retain'];
/**
 * An object representing categorized style props. Props are categorized
 * depending on their inheritability (flow, retain), target (block, text)
 * and (react) native support (native, web).
 */
var CSSProcessedProps = /*#__PURE__*/function () {
  function CSSProcessedProps() {
    _classCallCheck(this, CSSProcessedProps);
    _defineProperty(this, "native", void 0);
    _defineProperty(this, "web", void 0);
    this.native = this.newCompatCategory();
    this.web = this.newCompatCategory();
  }
  _createClass(CSSProcessedProps, [{
    key: "newCompatCategory",
    value: function newCompatCategory() {
      return {
        block: {
          retain: _emptyProps.emptyProps,
          flow: _emptyProps.emptyProps
        },
        text: {
          retain: _emptyProps.emptyProps,
          flow: _emptyProps.emptyProps
        }
      };
    }
  }, {
    key: "withProperty",
    value: function withProperty(propertyName, propertyValue, _ref) {
      var compatCategory = _ref.compatCategory,
        displayCategory = _ref.displayCategory,
        propagationCategory = _ref.propagationCategory;
      if (propertyValue !== null) {
        var target = this[compatCategory][displayCategory][propagationCategory];
        if (!(0, _emptyProps.isNotEmpty)(target)) {
          this[compatCategory][displayCategory][propagationCategory] = {};
        } //@ts-ignore

        this[compatCategory][displayCategory][propagationCategory][propertyName] = propertyValue;
      }
      return this;
    }
    /**
     * Create a new processed prop object by merging the 'overriders' parameters
     * into this object.
     *
     * @param overriders - The processed props which will be merged into this
     * processed prop. Rightmost props will override leftmost props.
     */
  }, {
    key: "merge",
    value: function merge() {
      var _this = this;
      for (var _len = arguments.length, overriders = new Array(_len), _key = 0; _key < _len; _key++) {
        overriders[_key] = arguments[_key];
      }
      var filtered = overriders.filter(_emptyProps.isNotEmpty);
      var next = new CSSProcessedProps();
      var _loop = function _loop() {
        var compat = _compatCategories[_i];
        var _loop2 = function _loop2() {
          var display = _displayCategories[_i2];
          var _loop3 = function _loop3() {
            var propagation = _propagationCategorie[_i3];
            next[compat][display][propagation] = (0, _mergeProps.default)([_this[compat][display][propagation]].concat(_toConsumableArray(filtered.map(function (o) {
              return o[compat][display][propagation];
            }))));
          };
          for (var _i3 = 0, _propagationCategorie = propagationCategories; _i3 < _propagationCategorie.length; _i3++) {
            _loop3();
          }
        };
        for (var _i2 = 0, _displayCategories = displayCategories; _i2 < _displayCategories.length; _i2++) {
          _loop2();
        }
      };
      for (var _i = 0, _compatCategories = compatCategories; _i < _compatCategories.length; _i++) {
        _loop();
      }
      return next;
    }
  }], [{
    key: "new",
    value: function _new() {
      return new CSSProcessedProps();
    }
  }]);
  return CSSProcessedProps;
}();
exports.CSSProcessedProps = CSSProcessedProps;